import styles from './styles.module.sass';

const OrderFilter = (props) => {
    const {
        setOrder
    } = props

    const handleChange = (event) => {
        const { value } = event?.target
        setOrder(value)
    }

    return(
        <div className={styles?.styleSelec}>
            <select onChange={handleChange}>
                <option value="0">Relevancia</option>
                <option value="1">Menor precio</option>
                <option value="2">Mayor precio</option>
            </select>
        </div>
    )
}

export default OrderFilter